const actingUserDetails = {
    fullname: "",
    imgSrc: require("../../assets/header/default_profile_img.jpg"),
    navigation: [],
}

export default actingUserDetails;
